// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Main: {
    btn1: "All",
    btn2: "Main Courses",
    btn3: "Drinks",
    btn4: "Appetizers",
    btn5: "Desserts",
    btn6: "Salads",
    btn7: "Breakfast",
    btn8: "Nargile", 
  },
  Salad: {
    saladIsim1: "Tuna Salad",
    saladIcerik1: "Cherry tomatoes, olives, red onion, corn, capers, cucumber",
    saladIsim2: "Teriyaki Chicken Salad",
    saladIcerik2: "Corn, cherry tomatoes",
    saladIsim3: "Shrimp Avocado Salad",
    saladIcerik3: "Avocado, corn, cherry tomatoes",
    saladIsim4: "Tomato Cheese Salad",
    saladIcerik4: "Tomatoes, cucumber, feta cheese, onion, corn, olives",
  },
  Breakfast: {
    breakfastIsim1: "Menemen",
    breakfastIcerik1: "",
    breakfastIsim2: "Full Breakfast",
    breakfastIcerik2: "Sausage, pastry, French fries, honey, jam, butter, white cheese, cheddar, olives, cucumber, tomatoes, boiled egg",
    breakfastIsim3:"Fried Egg",
    breakfastIcerik3:"Roast beef, Egg",
    breakfastIsim4:"Egg with pastrami",
    breakfastIcerik4:"Pastrami, Egg",
  },
  Desserts: {
    tatliIsim1: "Cheesecake",
    tatliIcerik1: "Chocolate, Raspberry",
    tatliIsim2: "Soufflé",
    tatliIcerik2: "- Served with ice cream",
    tatliIsim3: "Panna Cotta",
    tatliIcerik3: "Raspberry",
    tatliIsim4: "Cornetto",
    tatliIcerik4: "ice cream",
    tatliIsim5: "Magnum",
    tatliIcerik5: "ice cream",
  },
  Drinks: {
    icecek1: "Cola Zero",
    icecek2: "Cola",
    icecek3: "Fanta",
    icecek4: "Sprite",
    icecek5: "Soda",
    icecek6: "Fusetea",
    icecek7: "Capy",
    icecek8: "Cola 1LT",
    icecek9: "Sprite 1LT",
    icecek10: "Fanta 1LT",
    icecek11: "Soda",
    icecek12: "Fruit Soda",
    icecek13: "Redbull",
    icecek14: "Tea",
    icecek15: "Oralet",
    icecek16: "Nescafe",
    icecek17: "Turkish Coffee",
    icecek18: "Water",
    icecek19: "Ayran",
    icecek20: "Cup of Tea",
    icecek21: "Bottle of Coke",
    icecek22: "Schweppes",
    icecek23: "Nescafe Varieties",
    icecek24: "Turnip",
  },
  Antre: {
    antreIsim1: "Potato Casserole",
    AntreIcerik1: "-",
    antreIsim2: "Mushroom with Cheese Baked in Oven",
    AntreIcerik2: "-",
    antreIsim3: "Double Potato Casserole",
    AntreIcerik3: "-",
    antreIsim4: "Shrimp Casserole",
    AntreIcerik4: "-",
    antreIsim5: "Onion Rings",
    AntreIcerik5: "-",
    antreIsim6: "Fried Calamari",
    AntreIcerik6: "-",
    antreIsim7: "Cigar Borek",
    AntreIcerik7: "- 8 pieces",
    antreIsim8: "Appetizer Platter",
    AntreIcerik8: "French fries, sausage, onion rings, cigar borek, nugget, breaded calamari",
    antreIsim9: "Chicken Wings",
    AntreIcerik9: "- Served with spicy sauce, French fries",
  },
  Course: {
    mnBaslik1: "Pizza Varieties",
    anaYemekIsim1: "Margherita Pizza",
    anaYemekIcerik1: "Mozzarella, sliced tomatoes",
    anaYemekIsim2: "Mixed Pizza",
    anaYemekIcerik2: "Salami, sausage, sucuk, mushrooms, green olives, peppers, corn, black olives",
    anaYemekIsim3: "Tuna Pizza",
    anaYemekIcerik3: "Tuna, onions, peppers, green olives, corn, black olives",
    anaYemekIsim4: "Chicken BBQ Pizza",
    anaYemekIcerik4: "Corn, peppers, onions, red bell peppers",
    anaYemekIsim5: "Bolognese Pizza",
    anaYemekIcerik5: "Ground beef, mozzarella",
    mnBaslik2: "Toasted Sandwich Varieties",
    anaYemekIsim6: "Mixed Toast",
    anaYemekIcerik6: "- Served with tomatoes and cucumbers",
    anaYemekIsim7: "Cheese Toast",
    anaYemekIcerik7: "- Served with tomatoes and cucumbers",
    anaYemekIsim8: "Double Cheese Toast",
    anaYemekIcerik8: "- Served with tomatoes and cucumbers",
    mnBaslik3: "Taco Varieties",
    anaYemekIsim9: "Meat Taco",
    anaYemekIcerik9: "Ground beef, onions, carrots, vegetables, mushrooms - served with French fries, chili sauce",
    anaYemekIsim10: "Chicken Taco",
    anaYemekIcerik10: "Chicken, onions, carrots, vegetables, mushrooms - served with French fries, chili sauce",
    anaYemekIsim11: "Shrimp Taco",
    anaYemekIcerik11: "Shrimp, onions, carrots, vegetables, mushrooms - served with French fries, chili sauce",
    mnBaslik4: "Grilled Meat Varieties",
    anaYemekIsim12: "Chicken Skewers",
    anaYemekIcerik12: "- Served with rice, French fries",
    anaYemekIsim13: "Ribeye Steak",
    anaYemekIcerik13: "- Served with French fries",
    anaYemekIsim14: "Meatballs",
    anaYemekIcerik14: "- Served with rice, French fries",
    anaYemekIsim15: "Burger",
    anaYemekIcerik15: "-",
    // ON ALTI YOK 
    mnBaslik5: "Burger Varieties",
    anaYemekIsim17: "Hamburger",
    anaYemekIcerik17: "- 120 grams",
    anaYemekIsim18: "Cheeseburger",
    anaYemekIcerik18: "- 120 grams",
    anaYemekIsim19: "Chicken Burger",
    anaYemekIcerik19: "- 120 grams",
    anaYemekIsim20: "Hamburger Menu",
    anaYemekIcerik20: "120 grams - Served with French fries and cola",
    anaYemekIsim21: "Cheeseburger Menu",
    anaYemekIcerik21: "120 grams - Served with French fries and cola",
    anaYemekIsim22: "Chicken Burger Menu",
    anaYemekIcerik22: "120 grams - Served with French fries and cola",
    mnBaslik6: "Chicken Dishes",
    anaYemekIsim23: "Chicken with Mushroom Sauce",
    anaYemekIcerik23: "- Served with mashed potatoes",
    anaYemekIsim24: "Chicken with Curry Sauce",
    anaYemekIcerik24: "- Served with rice and greens",
    anaYemekIsim25: "Schnitzel Plate",
    anaYemekIcerik25: "- Served with French fries",
    mnBaslik7: "Pasta Varieties",
    anaYemekIsim26: "Spaghetti Bolognese",
    anaYemekIcerik26: "-",
    anaYemekIsim27: "Penne Arrabiata",
    anaYemekIcerik27: "Garlic, olives, tomato sauce",
    anaYemekIsim28: "Creamy Chicken Penne with Curry",
    anaYemekIcerik28: "Mushrooms, cream",
    anaYemekIsim29: "Creamy Penne with Pesto Sauce",
    anaYemekIcerik29: "Mushrooms",
    anaYemekIsim30: "Creamy Lunguine with Shrimp",
    anaYemekIcerik30: "-",
    anaYemekIsim31: "Manti (Turkish Dumplings)",
    anaYemekIcerik31: "-",
    anaYemekIsim32: "Manti with Walnut Sauce",
    anaYemekIcerik32: "-",
    anaYemekIsim33: "Creamy Chicken and Mushroom Fettuccine",
    anaYemekIcerik33: "-",
    mnBaslik8: "Wrap Varieties",
    anaYemekIsim34: "Chicken Wrap",
    anaYemekIcerik34: "Chicken, peppers, onions, mushrooms, cheese, chili sauce",
    anaYemekIsim35: "Beef Wrap",
    anaYemekIcerik35: "Beef, peppers, onions, mushrooms, cheese, chili sauce",
    mnBaslik9: "Types of Fish",
    anaYemekIsim36: "Red Mullet",
    anaYemekIcerik36: "It is 500 grams",
    anaYemekIsim37: "Sea Bream",
    anaYemekIcerik37: "It is between 300-400 grams"
  },
  Other: {
    otherIsim1: "Mixed Hookah",
    otherIcerik1: "",
    otherIsim2: "Banana Strawberry Hookah",
    otherIcerik2: "",
    otherIsim3: "Lady Killer",
    otherIcerik3: "",
    otherIsim4: "Lav 66",
    otherIcerik4: "",
    otherIsim5: "Apple hookah",
    otherIcerik5: "",
}
}
